"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var is_1 = require("../helper/is");
var calculateBorderRadius = core_1.memo(function (values, ranges, easing) {
    var _a, _b;
    var min = ranges[0], max = ranges[1];
    var minMatch = (_a = is_1.borderRadiusRegex.exec(min)) === null || _a === void 0 ? void 0 : _a.slice(1);
    var maxMatch = (_b = is_1.borderRadiusRegex.exec(max)) === null || _b === void 0 ? void 0 : _b.slice(1);
    if (minMatch && minMatch.length === 8 && maxMatch && maxMatch.length === 8) {
        var _c = minMatch.map(function (item, index) {
            var value = core_1.interpolate(values, [parseFloat(item), parseFloat(maxMatch[index])], easing);
            return value;
        }), a = _c[0], b = _c[1], c = _c[2], d = _c[3], e = _c[4], f = _c[5], g = _c[6], h = _c[7];
        return a + "% " + b + "% " + c + "% " + d + "% / " + e + "% " + f + "% " + g + "% " + h + "%";
    }
    throw new Error("Modular System Error -> \"" + min + "\" or \"" + max + "\" is not a valid border radius value.");
});
exports.borderRadius = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return ranges[0];
    }
    return calculateBorderRadius(values, ranges, easing);
}; };
exports.useBorderRadius = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.borderRadius(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=borderRadius.js.map